/**
 * PANEL ROTALARI — TEK ENVANTER.
 *
 * Her rota BURADA doğar ve `route-gate.guard.spec.tsx` her rotanın kapı
 * sınıfını (herkese açık / kimlik arkasında) tek tek sorar: yeni bir rota
 * eklenip sınıflandırılmazsa test KIRILIR. "Rota ekledim, kapıyı unuttum"
 * sınıfı bu yüzden makineyle kapalıdır.
 *
 * Yollar Türkçedir (ürünün arayüz dili); panel iç araç olduğu için dil öneki
 * YOKTUR — dil seçimi kullanıcının tercihidir, adres değil.
 */
export const ROUTES = {
  /** Giriş: e-posta + şifre + tek kullanımlık kod. */
  signIn: '/giris',
  /**
   * İLK KURULUM — davet jetonuyla şifre belirleme (panel kimliği ayrımı ·
   * Karar 4c). Oturum GEREKTİRMEZ: personelin henüz şifresi yoktur, dolayısıyla
   * giriş de yapamaz. Panelde "şifremi unuttum" olmadığı için bu ekran
   * kilitlenen personelin TEK dönüş yoludur ve bağlantısı giriş ekranındadır
   * ("Davetim var").
   */
  setup: '/kurulum',
  /**
   * PANEL GİRİŞİ — ARTIK GERÇEK BİR EKRAN (kullanıcı kararı 2026-09-02 §3).
   *
   * Önceki hâli yönlendirmeydi ve gerekçesi "boş bir pano açıp içine
   * sıfır/tahmin sayı basmak md. 9'un ta kendisi olurdu" idi. Gerekçe artık
   * geçersiz: pano UYDURMA SAYI BASMIYOR — `admin/stats/*` uçları gerçek
   * toplulaştırma sorgularından besleniyor. Kullanıcının sorusu ("kaç etkinlik
   * var, kimler katılıyor, hangi şehirde kaç etkinlik") panelin kökünde
   * yanıtlanır.
   */
  home: '/',
  users: '/kullanicilar',
  moderation: '/moderasyon',
  reports: '/raporlar',
  verifications: '/dogrulamalar',
  /**
   * E-POSTA GÖNDERİMLERİ — salt okunur gönderim defteri.
   *
   * `staff:audit_read` ister ve o yetki YALNIZ `admin` rolündedir: burada
   * okunan şey moderasyon kararı değil, platformun posta defteridir.
   * `moderator` bağlantıyı görmez, adrese giderse dürüst "yetkin yok" yüzeyi
   * alır (`ScreenPermissionGate`).
   */
  emailDeliveries: '/e-posta-gonderimleri',
  /**
   * PERSONEL HESAPLARI (panel kimliği ayrımı · Karar 4c). Davet, yeniden
   * davet, davet iptali ve askı buradadır; yalnız `staff:account_manage`
   * taşıyan personel (admin) görür. Panelde "şifremi unuttum" olmadığı için
   * bu ekran kilitlenen personelin kurtarma yolunun ARAYÜZÜDÜR.
   */
  staff: '/personel',
  /**
   * SATIŞ ADAYLARI (kurum satışla açılır · P1/P2). Detay AYRI ROTA DEĞİLDİR:
   * sağdan açılan paneldir ve adresi `?aday=<kimlik>` ile taşır — personel
   * listede yerini kaybetmeden adaydan adaya geçer, bağlantı paylaşılabilir.
   * Yalnız `staff:sales_inquiry_manage` (admin) görür.
   */
  salesInquiries: '/satis-adaylari',
  /** KURUMLAR (P3) — "Kurum aç" diyaloğu (P4) bu ekrandan ve aday detayından açılır. */
  organizations: '/kurumlar',
  /**
   * KURUM DETAYI (P5) — künye, sahip daveti, kredi özeti, sözleşme, defter.
   * Ekran rotası DEĞİLDİR (yan gezinmede satırı yok): kurumlar listesinin
   * satırından açılır ve aynı yetki kapısını (`ROUTES.organizations`) taşır.
   */
  organizationDetail: '/kurumlar/:organizationId',
  /**
   * REFERANS (HEDİYE) KODLARI (P7). Kullanım detayı AYRI ROTA DEĞİLDİR: sağdan
   * açılan katmandır ve adresi `?kod=<kimlik>` ile taşır. Yalnız
   * `staff:credit_manage` (admin) görür: kod para tanımlar.
   */
  referralCodes: '/referans-kodlari',
} as const;

/** Kurum detayının somut adresi. */
export function organizationDetailPath(organizationId: string): string {
  return ROUTES.organizationDetail.replace(':organizationId', encodeURIComponent(organizationId));
}

/** Referans kodunun kullanım detayı (liste + sağ katman). */
export function referralCodeDetailPath(codeId: string): string {
  return `${ROUTES.referralCodes}?kod=${encodeURIComponent(codeId)}`;
}

/** Satış adayı detayının somut adresi (liste + sağ panel). */
export function salesInquiryDetailPath(inquiryId: string): string {
  return `${ROUTES.salesInquiries}?aday=${encodeURIComponent(inquiryId)}`;
}

export type RouteKey = keyof typeof ROUTES;

/** Oturum GEREKTİRMEYEN rotalar. Liste kapalıdır ve kısadır. */
export const PUBLIC_ROUTES: readonly string[] = [ROUTES.signIn, ROUTES.setup];

/**
 * Kimlik + rol kapısının ARKASINDAKİ rotalar.
 *
 * Kapı kolaylıktır, güvenlik değildir: gerçek sınır API'dedir. Bu liste
 * arayüzün neyi çizmeyeceğini söyler, verinin kime açık olduğunu değil.
 */
export const PROTECTED_ROUTES: readonly string[] = [
  ROUTES.home,
  ROUTES.users,
  ROUTES.moderation,
  ROUTES.reports,
  ROUTES.verifications,
  ROUTES.emailDeliveries,
  ROUTES.staff,
  ROUTES.salesInquiries,
  ROUTES.organizations,
  ROUTES.organizationDetail,
  ROUTES.referralCodes,
];

/**
 * EKRAN ÇİZEN rotalar — yan gezinmede karşılığı OLMAK ZORUNDA.
 *
 * `route-reachability.guard.spec.tsx` bu listeyi kabuğun bağlantılarıyla
 * karşılaştırır: kayıtsız rota da linksiz ekran da KIRAR (CLAUDE.md — ekran
 * eksiksizliği: "erişilemeyen ekran yapılmamış sayılır"). `home` ARTIK
 * BURADADIR (pano turu): kök ekran çizdiği için gezinmede de karşılığı olmak
 * zorundadır.
 */
export const SCREEN_ROUTES: readonly string[] = [
  ROUTES.home,
  ROUTES.users,
  ROUTES.moderation,
  ROUTES.reports,
  ROUTES.verifications,
  ROUTES.emailDeliveries,
  ROUTES.staff,
  ROUTES.salesInquiries,
  ROUTES.organizations,
  ROUTES.referralCodes,
];
